import React from 'react';

import { ActivitySectionLayout } from 'modules/components/layer32';
import { MilestoneTable } from 'modules/components/layer25';


export type MilestonesDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestonesDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <MilestoneTable.FC />
    </ActivitySectionLayout.FC>

  );
};
